module.exports = __webpack_public_path__ + "img/GT.027a4347.png";